export default __webpack_public_path__ + "static/media/flight-wing.e342f357.jpeg";